module.exports = __webpack_public_path__ + "static/furniture-listlink-banner-left-section-code-ab3642a95fca7984325ca4bdb2844df1.png";